<template>
    <form action="#" method="POST" submit.prevent="onSubmit">
        <div :class="{'active': isActive}" class="input-wrapper">
            <span>{{ __('Quick notes') }}</span>
            <div class="grow-wrap" :data-replicated-value="form.body">
                <textarea
                    v-model="form.body"
                    name="body"
                    :placeholder="__('Write yourself a quick note')"
                    required=""
                    @click="active"
                ></textarea>
            </div>
        </div>

        <div v-if="isActive" class="btn-group">
            <VButton v-if="!noteID" :label="__('Add')" size="sm" @onClick="submit" />
            <VButton v-else :label="__('Save')" size="sm" @onClick="update" />
            <VButton :label="__('Cancel')" variant="ghost" size="sm" @onClick="cancel" />
            <VButton v-if="noteID" variant="ghost" color="danger" icon="trash-red" size="sm" position="right" @onClick="remove" />
        </div>
    </form>
</template>

<script>
export default {
    props: {
        patientId: {
            type: Number,
            required: true
        },
        note: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            form: {
                is_sidebar_note: true,
                body: this.note ? this.note.body : null,
                name: lang.get('Quick notes'),
                date: null,
                coach_id: null
            },
            isActive: false,
            noteID: this.note ? this.note.id : null,
            tempNote: null
        }
    },
    async mounted() {
        const growers = document.querySelectorAll('.grow-wrap')

        growers.forEach((grower) => {
            const textarea = grower.querySelector('textarea')
            textarea.addEventListener('input', () => {
                grower.dataset.replicatedValue = textarea.value

            })
        })
    },
    methods: {
        active() {
            this.isActive = true
            this.tempNote = this.form.body
        },
        cancel() {
            this.isActive = false
            this.form.body = this.tempNote
        },
        async submit() {
            if (this.form.body) {
                this.form.coach_id = this.user.impersonator ? this.user.impersonator.coach_id : this.user.coach_id

                await axios.post(`/coaches/patients/${this.patientId}/notes`, this.form)
                    .then(r => {
                        this.isActive = false
                        this.noteID = r.data.id
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            }
        },
        async update() {
            this.form.coach_id = this.user.impersonator ? this.user.impersonator.coach_id : this.user.coach_id
            
            await axios.put(`/coaches/patients/${this.patientId}/notes/${this.noteID}`, this.form)
                .then(r => {
                    this.isActive = false
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },
        remove() {
            axios.delete(`/coaches/patients/${this.patientId}/notes/${this.noteID}`)
                .then(r => {
                    this.form = {
                        is_sidebar_note: true,
                        body: null,
                        name: lang.get('Quick notes'),
                        date: null,
                        coach_id: null
                    },
                    this.noteID = null
                    this.isActive = false
                })
        }
    }
}
</script>
